/**
 * Module-level store for structured page context data.
 *
 * Pages register their relevant context (IDs, filters, selections, etc.)
 * via the `useRegisterPageContext` hook. The floating assistant reads
 * this data at send-time and includes it in the API call so the AI
 * has access to structured identifiers, not just DOM text.
 */

export type PageContextData = Record<string, unknown>;

let currentData: PageContextData = {};
let currentVersion = 0;

export function setPageContext(data: PageContextData): number {
    const version = ++currentVersion;
    currentData = data;
    return version;
}

/**
 * Only clears if the given version matches the current registration,
 * preventing a late cleanup from wiping a newer page's data during
 * client-side navigation.
 */
export function clearPageContext(version: number): void {
    if (version === currentVersion) {
        currentData = {};
    }
}

export function getPageContext(): PageContextData {
    return currentData;
}
